'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TouchFeedback = require('./TouchFeedback');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TouchFeedback)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/lib/index.js
// module id = 969
// module chunks = 0 1